import { type PropsWithChildren, useRef } from "react";

import { ThemeContainerContext } from "../ThemeContainerContext";

export function BlablacarThemeProvider({ children }: PropsWithChildren) {
	const ref = useRef<HTMLDivElement>(null);
	return (
		<div
			style={{
				display: "contents",
			}}
			ref={ref}
		>
			<ThemeContainerContext value={ref}>{children}</ThemeContainerContext>
		</div>
	);
}
